var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hi-list',{attrs:{"items":_vm.groupMailList},on:{"select":_vm.select},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('v-list-item-content',[_vm._v(" "+_vm._s(item.name)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }